import { QueryParamsModel } from '../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { mergeMap, map, tap, delay } from 'rxjs/operators';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { scoringRecordsService } from '../_services';
import { AppState } from '../../reducers';
import {

    scoringRecordActionToggleLoading,
    scoringRecordActionTypes,
    scoringRecordsPageLoaded,
    scoringRecordsPageRequested,
    ScoringscoringRecordPageRequested,

    scoringRecordsPageToggleLoading,
    OnescoringRecordDeleted,
    scoringRecordOnServerCreated,
    scoringRecordCreated,
    scoringRecordUpdated,
    scoringRecordUpdated2,
    ScoringscoringRecordPageLoaded,


} from '../_actions/scoringRecord.actions';
import { of } from 'rxjs';

@Injectable()
export class scoringRecordEffects {
    showPageLoadingDistpatcher = new scoringRecordsPageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new scoringRecordActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new scoringRecordActionToggleLoading({ isLoading: false });

    @Effect()
    loadscoringRecordsPage$ = this.actions$.pipe(
        ofType<scoringRecordsPageRequested>(scoringRecordActionTypes.scoringRecordsPageRequested),
        mergeMap(( { payload } ) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.scoringRecordsService.findscoringRecords(payload.page);            
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];
            const pageLoadedDispatch = new scoringRecordsPageLoaded({
                scoringRecords: result
            });
            return pageLoadedDispatch;
        })
    );


    @Effect()
    loadScoringscoringRecordPageScoring$ = this.actions$.pipe(
        ofType<ScoringscoringRecordPageRequested>(scoringRecordActionTypes.ScoringscoringRecordPageRequested),
        mergeMap(( { payload } ) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.scoringRecordsService.findscoringRecords(payload.page);            
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];            
            const lastQuery: QueryParamsModel = response[1];
            const pageLoadedDispatch = new ScoringscoringRecordPageLoaded({
                scoringRecords: result
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteCustomer$ = this.actions$
        .pipe(
            ofType<OnescoringRecordDeleted>(scoringRecordActionTypes.OnescoringRecordDeleted),
            mergeMap(( { payload } ) => {
                    this.store.dispatch(this.showActionLoadingDistpatcher);
                    return this.scoringRecordsService.deletescoringRecord(payload.id);
                }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

        @Effect()
        createscoringRecord$ = this.actions$
            .pipe(
                ofType<scoringRecordOnServerCreated>(scoringRecordActionTypes.scoringRecordOnServerCreated),
                mergeMap(( { payload } ) => {
                    this.store.dispatch(this.showActionLoadingDistpatcher);
                    return this.scoringRecordsService.createscoringRecord(payload.scoringRecord).pipe(
                        tap(res => {
                            this.store.dispatch(new scoringRecordCreated({ scoringRecord: res }));
                        })
                    );
                }),
                map(() => {
                    return this.hideActionLoadingDistpatcher;
                }),
            );

            @Effect()
            updateToggel$ = this.actions$
                .pipe(
                    ofType<scoringRecordUpdated>(scoringRecordActionTypes.scoringRecordUpdated),
                    mergeMap(( { payload } ) => {                        
                        this.store.dispatch(this.showActionLoadingDistpatcher);
                        this.scoringRecordsService.updatescoringRecord(payload.scoringRecord);
                        return this.scoringRecordsService.updatescoringRecord(payload.scoringRecord);
                    }),
                    map(() => {
                        return this.hideActionLoadingDistpatcher;
                    })
                );
                @Effect()

                updateToggel2$ = this.actions$
                .pipe(
                    ofType<scoringRecordUpdated2>(scoringRecordActionTypes.scoringRecordUpdated2),
                    mergeMap(( { payload } ) => {                                                
                        this.store.dispatch(this.showActionLoadingDistpatcher);
                        this.scoringRecordsService.updatescoringRecord2(payload.scoringRecord,payload.type);
                        return this.scoringRecordsService.updatescoringRecord2(payload.scoringRecord,payload.type);
                    }),
                    map(() => {
                        return this.hideActionLoadingDistpatcher;
                    })
                );
    constructor(private actions$: Actions, private scoringRecordsService: scoringRecordsService, private store: Store<AppState>) { }

}
